import { COMPONENTS } from '../../../components/components.registry';
import { ResultsNumberConfig } from '../../../models';

export const DEFAULT_RESULTS_NUMBER_CONFIG: ResultsNumberConfig = {
  components: {
    resultsNumber: COMPONENTS.PURE.DefaultResultsNumber
  }
};
